<template>
	<div class="gatherers">
			<div class="section1 section first">				
				<div class="vacancy">
					<div class="content-text">
						<h3 class="section-text1 title textfade textfade1">{{text.first.title}}</h3>
						<p class="section-text2 text textfade textfade2">{{text.first.text}}</p>
					</div>
					<div class="plane-wrap" v-if="isMobile">
						<img class="init-img" src="../assets/image/gatherers3/first/00.png" alt="">
						<div class="swiper-container first-img-swiper">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<img src="../assets/image/gatherers3/first/029.png" alt="" srcset="">
									<p class="img-text">{{text.first.tips[0]}}</p>
								</div>
								<div class="swiper-slide">
									<img src="../assets/image/gatherers3/first/057.png" alt="" srcset="">
									<p class="img-text">{{text.first.tips[1]}}</p>
								</div>
								<div class="swiper-slide">
									<img src="../assets/image/gatherers3/first/092.png" alt="" srcset="">
									<p class="img-text">{{text.first.tips[2]}}</p>
								</div>
								<div class="swiper-slide">
									<img src="../assets/image/gatherers3/first/0124.png" alt="" srcset="">
									<p class="img-text">{{text.first.tips[3]}}</p>
								</div>
							</div>
						</div>
						<div class="pagination pagination-mini">
							<i class="planei plane1i-1"></i
							><i class="planei plane1i-2"></i
							><i class="planei plane1i-3"></i
							><i class="planei plane1i-4"></i>
						</div>
					</div>
					<div class="plane-wrap" v-else>
						<canvas
							class="plane1-img canvas"
							id="canvas1"
							width="1600"
							height="800"
						></canvas>
						<p class="plane1-text">{{text.first.tips[0]}}</p>
						<p class="plane1-text">{{text.first.tips[1]}}</p>
						<p class="plane1-text">{{text.first.tips[2]}}</p>
						<p class="plane1-text">{{text.first.tips[3]}}</p>
						<div class="pagination pagination1">
							<i class="planei plane1i-1"></i
							><i class="planei plane1i-2"></i
							><i class="planei plane1i-3"></i
							><i class="planei plane1i-4"></i>
						</div>
					</div>
				</div>
			</div>
			<div class="section2 section">
				<picture>
					<source	srcset="../assets/image/gatherers3/p2-mobile.png" media="(max-width: 600px)"/>
					<img class="bg" src="../assets/image/gatherers3/p2-bg.jpg" alt=""/>
				</picture>
				<canvas
						class="second-plane canvas"
						id="canvas2"
						width="2560"
						height="1600"
					></canvas>
				<div class="content">
					<h3 class="section-text1 title textfade">{{text.second.title}}</h3>
					<p class="section-text2 text textfade">{{text.second.text}}</p>
				</div>
			</div>
			<div class="section3 section">
				
				<div class="plane-wrap clearfix">
					<div class="left">
						<picture
							>
							<img
								class="s3img"
								src="../assets/image/gatherers3/s3place.png"
								alt=""/></picture
						><picture
							><source
								srcset="../assets/image/gatherers3/s3show@2x.png"
								media="(max-width: 600px)"/>
							<img
								class="s3show"
								src="../assets/image/gatherers3/s3show.png"
								alt=""
						/></picture>
					</div>
					<div class="right clearfix">
						<div class="content">
							<h3 class="section-text1 title textfade">{{text.third.title}}</h3>
							<p class="section-text2 text textfade">{{text.third.text}}</p>
						</div>
						<div
							class="swiper-container swiper-no-swiping s3swiper"
						>
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<picture
										><source
											srcset="../assets/image/gatherers3/right1-mobile.png"
											media="(max-width: 600px)"/>
										<img
											class="r1"
											src="../assets/image/gatherers3/right1.png"
											alt=""
									/></picture>
									<p class="module-text">{{text.third.tips[0]}}</p>
								</div>
								<div class="swiper-slide">									
									<picture
										><source
											srcset="../assets/image/gatherers3/right2-mobile.png"
											media="(max-width: 600px)"/>
										<img
											class="r2"
											src="../assets/image/gatherers3/right2.png"
											alt=""
									/></picture>
									<p class="module-text">{{text.third.tips[1]}}</p>
								</div>
								<div class="swiper-slide">
									<picture
										><source
											srcset="../assets/image/gatherers3/right3-mobile.png"
											media="(max-width: 600px)"/>
										<img
											class="r3"
											src="../assets/image/gatherers3/right3.png"
											alt=""
									/></picture>
									<p class="module-text">{{text.third.tips[2]}}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="section4 section">
				<div class="img-wrap">
					<picture>
						<source	srcset="../assets/image/gatherers3/p4-mobile.png" media="(max-width: 600px)"/>
						<img class="bg" src="../assets/image/gatherers3/p4-bg.png" alt=""/>
					</picture>
					<img class="grid" src="../assets/image/gatherers3/p4-grid.png">
				</div>
				<div class="content">
					<h3 class="section-text1 title textfade">{{text.forth.title}}</h3>
					<p class="section-text2 text textfade">{{text.forth.text}}</p>
				</div>
			</div>
			<div class="section5 section">
				<div class="content">
					<h3 class="section-text1 title textfade">
						<span>{{text.fifth.title}}</span>
					</h3>
					<div
						class="content-text section-text2 textfade"
					>
						<p class="text">{{text.fifth.text}}</p>
					</div>
					<ul class="textfade clearfix">
						<li>
							<i class="content-icon icon5"></i
							><span>{{text.fifth.tips[0]}}</span>
						</li>
						<li>
							<i class="content-icon icon6"></i
							><span>{{text.fifth.tips[1]}}</span>
						</li>
						<li>
							<i class="content-icon icon7"></i
							><span>{{text.fifth.tips[2]}}</span>
						</li>
					</ul>
				</div>
				<img
					src="../assets/image/gatherers3/s5pc.png"
					alt=""
				/>
			</div>
		<Params  :direction="isMobile?'horizon':'vertical'" :params="text.params" />
		<foot></foot>
	</div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
import { init } from '@/js/gathers.js'
import { isMobile } from '@/js/utils.js'
import { collector } from '@/js/text.js'

export default {
	name: 'gatherers',
    metaInfo: {
		meta: [{
			name: 'keywords', 
			content: '手抛, 固定翼, 无人机, 碳纤维, 载荷,POS,  航测,倾斜,正射,  多光谱, RTK'
		},{
			name: 'description', 
			content: '采集者是一套手抛固定翼地理信息采集系统，机身为碳纤维骨架，智能电池设计，整机快装结构，2分钟快速展开；标准化的载荷模块设计，支持一机多用，覆盖多种航测作业。无工具拆装，倾斜、正摄、多光谱多模块轻松互换。通过搭载全新的RTK、PPK双差分一体的导航定位模块，将定位精度提升至厘米级，双差分定位有效提升了采集者的飞行安全，同时为在复杂地形进行倾斜摄影测量提供高精度数据。'
		}]
	},
	data() {
		return {
			plane1img: null,
			plane2img: null,
			swiper3: null,
			isMobile: false
		}
	},
	components: {
		Foot: () => import('@/components/footer.vue'),
		Params: () => import('@/components/params.vue')
	},
	computed: {
		text() {
			return this.$route.params.lang === 'CN' ? collector.CN : collector.EN
		}
	},
	watch: {
		$route(val) {
			for(let i=0; i< this.swiper3.slides.length; i++) {
				let p = this.swiper3.slides[i].getElementsByTagName('p')[0]
				p.innerText = this.text.third.tips[i % 3]
			}
			if(this.isMobile) {
				Array.from(document.getElementsByClassName('first-img-swiper')[0].getElementsByClassName('img-text')).forEach((item,i ) => {
					if(item.parentNode.dataset.swiperSlideIndex) {
						item.innerText = this.text.first.tips[item.parentNode.dataset.swiperSlideIndex]
					}				
				})
			}			
		}
	},
	methods: {
		...mapMutations(['setHeaderStyle'])
	},
	created() {
		this.isMobile = isMobile() || window.innerWidth < 600
	},
	mounted() {
		this.setHeaderStyle({headerStyle: 'light'})
		let { plane1img, plane2img, swiper3 } = init(this)
		this.plane1img = plane1img
		this.plane2img = plane2img
		this.swiper3 = swiper3
	},
	beforeDestroy() {
		window.onscroll = null
		this.plane2img.pause()
		if(!this.isMobile) {
			this.plane1img.pause()
		}
	}
}
</script>

<style lang="scss">
@import '../assets/css/gatherers.scss';
</style>
